export default class Customer {

  id = null;
  parentId = null;

  name = "";
  street = "";
  zip = "";
  city = "";
  country = null
  province = null;

  contactName = "";
  contactMail = "";
  contactPhone = "";

  websiteUrl = "";
  reportFooterContent = "";
  logoUrl = "";
  tags = [];
  blackTags = [];
  provision = 0;

  options = [];
  type = "";

  inhouse = 1; // default value

  createdAt = null;

  constructor() {
  }
}
